import { Flex, spacing, StyleProps, useIsMobileView } from 'deepstash-ui';
import React from 'react';
import IdeaCard from 'src/components/idea-card/IdeaCard';
import SectionTitle from 'src/components/layout/components/SectionTitle';
import SubsectionHeader from 'src/components/metacontent/components/SubsectionHeader';
import { Idea } from 'types/models';
import {
  GAP_SIZE_REM,
  getRemWidthFromColumns,
  SECTION_GAP_REM,
} from 'utils/global';
import commonStrings from 'utils/strings/commonStrings';

interface SimilarIdeasListProps {
  originalIdeaTitle?: string;
  similarIdeas?: Idea[];
}

const SimilarIdeasList: React.FC<SimilarIdeasListProps & StyleProps> = ({
  originalIdeaTitle,
  similarIdeas,
  ...props
}) => {
  const isMobileView = useIsMobileView();

  if (!similarIdeas || similarIdeas.length === 0) return null;

  const renderIdeaCard = (idea: Idea) => (
    <section id={`${idea.id}`}>
      <IdeaCard
        ideaData={{ idea, source: null }}
        preloadImage={true}
        w={{
          base: '100%',
          md: getRemWidthFromColumns(6),
        }}
        ml={{ base: 0, md: getRemWidthFromColumns(1) }}
        transition={'all 0.2s cubic-bezier(.43,.22,.05,.99)'}
        zIndex={1}
        minH="auto"
        userSelect={'text'}
        isNotInteractable
      />
    </section>
  );

  return (
    <Flex width={'100%'} flexDirection={'column'} {...props}>
      {isMobileView ? (
        <SubsectionHeader
          pt={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
          pb={GAP_SIZE_REM}
          headingSize="h3"
        >
          {commonStrings.metacontent.similarSourcesSectionHeader}
          {originalIdeaTitle && ` to ${originalIdeaTitle}`}
        </SubsectionHeader>
      ) : (
        <SectionTitle
          pt={SECTION_GAP_REM}
          pb={spacing.toRem(48)}
          ml={getRemWidthFromColumns(1)}
          title={
            commonStrings.metacontent.similarSourcesSectionHeader +
            (originalIdeaTitle && ` to ${originalIdeaTitle}`)
          }
        />
      )}

      <Flex
        flexDir="column"
        w="100%"
        position="relative"
        gridGap={GAP_SIZE_REM}
        pb={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
      >
        {similarIdeas.map(idea => {
          return renderIdeaCard(idea);
        })}
      </Flex>
    </Flex>
  );
};

export default SimilarIdeasList;
